export const coerceToString = (value: unknown): string => (value == null ? '' : String(value));

export const coerceToTimestamp = (value: unknown): string | number | Date | null => {
  if (value == null) return null;
  if (typeof value === 'string' || typeof value === 'number' || value instanceof Date) return value;
  return null;
};
